import { type FC, useMemo } from "react";
import { SWReactIcons } from "@similarweb/icons";
import TrialText from "app/components/React/TrialBanner/TrialText/TrialText";
import CTAButton from "app/components/React/TrialBanner/CTAButton/CTAButton";
import { trialBannerTheme } from "app/components/React/TrialBanner/StyledTrialBanner";
import { i18n } from "app/components/React/TrialBanner/TrialBanner";
import { getBannerType, getCTAButtonOnClick } from "app/components/React/TrialBanner/utils/trialBannerLogic";
import { swSettings } from "app/common/services/swSettings";
import { isShopperICPBanner } from "../utils/trialBannerHelpers";

interface BannerCTAProps {
    isSalesApp: boolean;
    shouldGoToAfterTrial?: boolean;
}

const BannerCTA: FC<BannerCTAProps> = ({ isSalesApp, shouldGoToAfterTrial }) => {
    const bannerType = useMemo(() => getBannerType(swSettings), [swSettings]);
    const isICPBanner = isShopperICPBanner(bannerType);

    const { ctaTextKey, ctaOnClick } = getCTAButtonOnClick({
        bannerType,
        isSalesApp,
        isICPBanner
    });

    return (
        <>
            {!isICPBanner && (
                <SWReactIcons
                    iconName="avg-visit-duration"
                    size="sm"
                />
            )}

            <TrialText
                bannerType={bannerType}
                shouldGoToAfterTrial={shouldGoToAfterTrial}
            />
            {ctaTextKey && ctaOnClick && (
                <CTAButton
                    text={i18n(ctaTextKey)}
                    onClick={ctaOnClick}
                    theme={trialBannerTheme}
                    isShopperICPBanner={isICPBanner}
                />
            )}
        </>
    );
};

export default BannerCTA;
